/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-21 15:01:35
 */


export default {
	"route.dashboard": "대시보드",
	"route.robot": "로봇 ",
	"route.robotList": "로봇 리스트",
	"route.groupManage": "그룹 관리",
	"route.disinfect": "임무",
	"route.home": "홈페이지",
	"route.disinfectTask": "임무",
	"route.building": "건물",
	"route.accessControl": "출입구",
	"route.ladderControl": "계단 컨트롤",
	"route.IOT": "IOT",
	"route.accounts": "계정",
	"route.roles": "역할",
	"route.jurisdiction": "권한",
	"route.dispatcher": "배송인",
	"navbar.logOut": "로그아웃",
	"login.title": "기업아이디 로그인",
	"login.logIn": "로그인",
	"login.username": "아이디",
	"login.tip_username": "아이디를 입력하세요",
	"login.password": "비밀번호",
	"login.company_id": "기업번호",
	"login.tip_company": "기업번호를 입력하십시오",
	"login.tip_pwd": "비밀번호를 입력하십시오",
	"robot.projectTtitle": "로봇 관리 계정",
	"robot.manage": "로봇 관리",
	"system.search": "검색",
	"system.reset": "초기화",
	"system.open": "더보기",
	"system.retract": "닫기",
	"system.status": "상태",
	"system.inProgress": "진행 중",
	"system.normalCompletion": "완성",
	"system.abnormalEnd": "오류 ",
	"system.noData": "데이터 없음",
	"universality.confirm": "확인",
	"universality.cancel": "취소",
	"universality.Pleasedonot": "입력이 비어있으면 안됩니다",
	"universality.Pleaseifsymbols": "6-20자의 숫자, 영문자, 특수문자를 입력하십시오 ",
	"disinfect.robotremarkname": "로봇 비고명",
	"disinfect.EnterNoteName": "비고명을 입력하십시오.",
	"disinfect.robotSerialNumber": "로봇 일련번호",
	"disinfect.inputSequenceNumber": "일련번호를 입력하십시오.",
	"disinfect.selectStatus": "상태를 선택하십시오.",
	"disinfect.destination": "목적지",
	"disinfect.Enterdestination": "목적지를 입력하십시오.",
	"disinfect.dates": "날짜",
	"disinfect.tos": "까지",
	"disinfect.startDates": "시작일",
	"disinfect.endDates": "종료일",
	"disinfect.starttimes": "시작시간",
	"disinfect.endtimes": "종료시간",
	"disinfect.Lastweek": "최근 한주",
	"disinfect.Lastmonth": "최근 한달",
	"disinfect.Lastthreemonths": "최근 3개월",
	"disinfect.nonExecution": "미실행",
	"disinfect.canceled": "취소",
	"disinfect.UnclaimedProperty": "픽업되지 않음",
	"disinfect.hardwareFailure": "하드웨어 고장",
	"disinfect.NavigationFault": "내비게이션 고장",
	"disinfect.Manualcancellation": "수동 취소",
	"navigationBar.logout": "로그아웃",
	"navigationBar.logoutandsystem": "로그아웃하고 나가시겠습니까?",
	"account.userlist": "계정 리스트",
	"account.searchnames": "계정 및 이름 검색",
	"account.adduser": "계정 추가",
	"account.user": "아이디",
	"account.roles": "역할",
	"account.ResponsibleRobot": "로봇 책임",
	"account.name": "이름",
	"account.remark": "비고",
	"account.Recentloginiof": "최근 로그인 정보",
	"account.operation": "조작",
	"account.compile": "편집",
	"account.resetpasswords": "비밀번호 초기화",
	"account.delete": "삭제",
	"account.pleaseuserpasnumb": "6-20자 영문자, 숫자, 특수문자",
	"account.pleasepasswordnumb": "6-20자 영문자, 숫자, 특수문자)",
	"account.selectroles": "역할 선택",
	"account.selectbuild": "건물 선택",
	"account.inputnames": "사용자 이름 입력",
	"account.inputremarks": "비고 입력",
	"account.userdetail": "계정 상세보기",
	"account.platform": "대",
	"account.noBindingRobot": "연동된 로봇이 없습니다",
	"account.addtimes": "시간 추가",
	"account.LastonlineTime": "최근 인터넷 접속 시간",
	"account.Resetsuccessfully": "초기화 성공",
	"account.initialPassword": "초기 비밀번호",
	"account.gotIt": "알겠습니다",
	"account.PleaseRoles": "역할을 선택하십시오",
	"account.Pleasebuilds": "건물을 선택하십시오",
	"account.PleaseRobots": "로봇을 선택하십시오",
	"account.compileusers": "계정 편집",
	"account.deleteusers": "계정 삭제",
	"account.Unabletologinafterdeleting": "계정을 삭제하면 다시 로그인할 수 없습니다. 그래도 삭제하시겠습니까?",
	"account.alreadyexistsConfirmpasswords": "해당 비밀번호로 바꾸시겠습니까?",
	"account.alreadyExists": "아이디가 이미 존재합니다",
	"map.deleteThecloudmap": "클로우드 지도를 삭제하면 관련된 모든 로봇에 있는 지도가 삭제됩니다. 그래도 삭제하시겠습니까?",
	"map.deletemaps": "지도 삭제",
	"homes.robotTotal": "로봇 수량(대)",
	"homes.tasksTotal": "누계 임무 수량 (개)",
	"homes.onlineTimeTotal": "누계 온라인 시간",
	"homes.nearly-7-days-onlineTime": "최근 7일 온라인 시간 추세",
	"homes.cumulativeMileage": "누계 거리(미터)",
	"homes.robotWorkingHoursData": "로봇 임무수행  데이터 ",
	"homes.trendWorkingHours": "로봇이 임무수행 시간추세",
	"homes.explain": "설명",
	"homes.explainContent": "다양한 건물에서의 로봇 배송 데이터",
	"homes.to": "까지 ",
	"homes.startTime": "시작시간",
	"homes.endTime": "종료시간",
	"homes.proportionWorkingHours": "임무 수행시간 비율",
	"homes.buildingDeliveryList": "건물 배송 횟수 랭킹",
	"public.second": "번",
	"public.rice": "미터",
	"public.lastSevenDays": "최근 7일",
	"public.lastFourteenDays": "최근 14일",
	"public.lastThirtyDays": "최근 30일",
	"robotState.notActive": "활성화하지 않음",
	"robotState.abnormalEnd": "이상 종료",
	"robotState.hasLeft": "이미 떠남",
	"robotState.online": "온라인 ",
	"robotState.offline": "오프라인",
	"robotState.charge": "충전",
	"robotState.unknown": "모름",
	"robotState.atWork": "임무 수행 중",
	"robotState.free": "대기하다",
	"robotState.unexecuted": "임무 미실행",
	"robotState.executing": "임무 실행 중",
	"robotState.canceled": "취소됨",
	"robotState.Completed": "완성",
	"robotState.nobodyTakesThings": "픽업되지 않음",
	"robot.robotList": "로봇 리스트",
	"robot.buildings": "소속 건물",
	"robot.selectBuilding": "건물 선택",
	"robot.search": "비고명, 일련 번호 검색",
	"robot.notAddRobot": "로봇을 추가 또는 활성화하지 않았습니다",
	"robot.mileage": "누적 거리",
	"robot.information": "기본 정보",
	"robot.noteName": "비고명",
	"robot.model": "모델명 ",
	"robot.onlineStatus": "온라인 상태",
	"robot.workingStatus": "임무 실행 상태",
	"robot.currentPower": "현재 남은 배터리",
	"robot.serialNumber": "일련 번호",
	"robot.operationData": "실행 데이터",
	"robot.latestOnlineTime": "최근 인터넷 접속 시간",
	"robot.cumulativeOnlineDuration": "누적 온라인 시간",
	"robot.cumulativeDeliveryTimes": "누적 배송 횟수",
	"robot.cumulative-delivery-time": "누적 배송 시간",
	"robot.cumulativeLeadTimes": "누적 가이드 횟수",
	"robot.cumulativeLeadTime": "누적 가이드 시간",
	"robot.System-Hardware": "시스템과 하드웨어",
	"robot.systemVersion": "시스템 버전",
	"robot.hardwareStatus": "하드웨어 상태",
	"robot.language": "시스템 언어",
	"robot.voice_pack": "보이스 팩",
	"robot.box_model": "배송 박스",
	"robot.android_soft": "안드로이드 앱",
	"robot.android_mirror": "안드로이드 미러",
	"robot.header_control": "헤더 컨트롤",
	"robot.under_panel_version": "베이스 버전",
	"robot.under_mirror": "베이스 미러",
	"robot.under_master": "베이스 메인 컨트롤",
	"robot.under_control": "베이스 컨트롤 ",
	"robot.rgbd_up": "RGBD(상)",
	"robot.rgbd_down": "RGBD(하)",
	"robot.doorControlMotor": "도어 컨트롤 모터",
	"robot.frontMountedCamera": "프론트 카메라 ",
	"robot.overheadCamera": "상단 카메라",
	"robot.infraredDetectionBox": "배송 박스 내 적외선 테스트",
	"robot.microphone": "마이크",
	"robot.radar": "레이더",
	"robot.head-RGBD": "헤드RGBD",
	"robot.bottom-RGBD": "베이스RGBD",
	"robot.ultrasonicSensor": "초음파 센서",
	"robot.IMU": "IMU",
	"robot.hubMotor": "바퀴모터",
	"robot.emergencyStopSwitch": "급정지 스위치",
	"robot.horn": "나팔",
	"robot.getFailed": "획득 실패",
	"robot.normal": "정상",
	"robot.abnormal": "이상",
	"robot.cancel": "취소",
	"robot.confirm": "확인",
	"public.noteNameCannotBeEmpty": "비고명이 비어있으면 안됩니다",
	"public.layer": "층",
	"public.door": "동",
	"public.rename": "이름 바꾸기",
	"public.delete": "삭제",
	"robot.percentageTasksCompletedTotal": "누적 임무 완성 상황",
	"robotState.workSuspension": "임무 스톱",
	"buiding.buildingList": "건물 리스트",
	"buiding.add": "추가",
	"buiding.addFloors": "건물 추가",
	"buiding.pleaseCompleteBuidingsData": "왼쪽 건물 리스트에서 건물 정보를 보충하십시오 ",
	"buiding.map": "지도 ",
	"buiding.source": "출처",
	"buiding.uploadTime": "업로드 시간",
	"buiding.pleaseRobotUploadMap": "로봇 플롯폼에서 지도를 먼저 업로드하세요 ",
	"buiding.associatedBuildings": "관련 건물 ",
	"buiding.robot": "로봇 ",
	"buiding.associatedRobot": "관련 로봇 ",
	"buiding.associatedShop": "관련 스토어 ",
	"buiding.type": "유형:",
	"buiding.pleaseType": "유형을 선택하십시오",
	"buiding.buildingName": "건물 이름",
	"buiding.pleaseBuildingName": "건물 이름을 입력하십시오",
	"buiding.shopName": "스토어 이름",
	"buiding.pleaseShopName": "스토어 이름을 입력하십시오",
	"buiding.floor": "층",
	"buiding.floorName": "층 이름",
	"buiding.pleaseFloorName": "층 이름 ",
	"buiding.floorNameBeEmpty": "층 이름이 비어있으면 안됩니다",
	"buiding.buid": "건물",
	"buiding.shop": "스토어",
	"buiding.serialNumberCannotBeEmpty": "시리얼 번호가 비어있으면 안됩니다",
	"buiding.buildingAdd": "건물 추가",
	"buiding.pleaseBuilsdingName": "건물 이름을 입력하십시오",
	"buiding.buildingsNameBeEmpty": "건물 이름이 비어있으면 안됩니다",
	"buiding.AreYouSureToDeleteThisFloor": "해당 층을 삭제하시겠습니까?",
	"buiding.deleteFloor": "층 삭제",
	"buiding.AreYouSureToDeleteThisShop": "해당 스토어를 삭제하시겠습니까?",
	"buiding.deleteShop": "스토어 삭제",
	"buiding.AreYouSureToDeleteThisBuilding": "해당 건물을 삭제하시겠습니까?",
	"buiding.deleteBuilding": "건물 삭제",
	"buiding.editBuilding": "건물 편집 ",
	"buiding.editFloor": "층수 편집",
	"buiding.editShop": "스토어 편집",
	"buiding.shopNameAlreadyExists": "스토어 이름이 이미 존재합니다",
	"buiding.shopAddSuccess": "스토어 추가 성공",
	"buiding.floorNameAlreadyExists": "층 이름이 이미 존재합니다",
	"buiding.floorAddSuccess": "층 추가 성공",
	"buiding.buildingNameAlreadyExists": "층 이름이 이미 존재합니다",
	"buiding.buildingAddSuccess": "건물 추가 성공 ",
	"buiding.shopEditSuccess": "스토어 편집 성공",
	"buiding.buildingEditSuccess": "건물 편집 성공",
	"buiding.floorEditSuccess": "층수 편집 성공",
	"buiding.selectRobot": "로봇 선택",
	"buiding.replacementBuildings": "건물 바꾸기",
	"role.rolelist": "역할 리스트",
	"role.addroles": "역할 추가",
	"role.names": "이름",
	"role.Entername": "이름 입력",
	"role.PleaseEntername": "이름을 입력하십시오",
	"role.editroles": "역할 편집",
	"role.deleteroles": "역할 삭제",
	"role.Confirmdeletion": "삭제한 역할을 다시 복귀할 수 없습니다. 그래도 삭제하시겠습니까?",
	"role.nameAlreadyExists": "역할 이름이 이미 존재합니다",
	"navigationBar.personalInfo": "개인 정보",
	"navigationBar.changePassword": "비밀번호 수정",
	"navigationBar.administrator": "매니저",
	"navigationBar.domesticConsumer": "일반 고객",
	"navigationBar.originalPsd": "초기 비밀번호",
	"navigationBar.EnterOriginalPsd": "초기 비밀번호를 입력하십시오",
	"navigationBar.newPassword": "새 비밀번호",
	"navigationBar.confirmPassword": "비밀번호 확인",
	"navigationBar.EntertheNewPsdAga": "새 비밀번호를 다시 입력해주세요",
	"navigationBar.TheOriPsdCannotEmpty": "초기 비밀번호가 비어있으면 안됩니다",
	"navigationBar.TheNewPsdempty": "새 비밀번호가 비어있으면 안됩니다",
	"navigationBar.PleEntertheNewPsdAga": "새 비밀번호를 다시 한번 입력해주세요",
	"navigationBar.TheNewPasastheoldone": "새 비밀번호가 초기 비밀번호와 일치합니다",
	"navigationBar.Psdisinconsistentwith": "다시 입력하신 비밀번호가 새 비밀번호와 일치하지 않습니다",
	"navigationBar.modifySuccessfully": "고치기 성공",
	"accessControl.accessControlList": "출입구 리스트",
	"accessControl.floor": "소속 층",
	"accessControl.accessControlAdd": "출입구 추가",
	"accessControl.accessControlID": "출입구 ID",
	"accessControl.selectAccessControlID": "출입구 아이디를 선택",
	"accessControl.accessControlID-Hint": "출입구 서비스를 확인했습니다. 해당 고객은",
	"accessControl.label": "비고명",
	"accessControl.pleaseLabel": "비고명 입력",
	"accessControl.deleteAccessControl-Hint": "출입구를 삭제하면 로봇이 혼자 자동문을 지나갈 수 없게 됩니다. 그래도 삭제하시겠습니까?",
	"accessControl.deleteAccessControl": "출입구 삭제",
	"accessControl.editAccessControl": "출입구 편집",
	"accessControl.accessControlIdExists": "출입구 아이디가 이미 존재합니다",
	"public.notAssociatedFloor": "소속 층과 연동되지 않았습니다",
	"public.notAssociatedBuilding": "소속 건물과 연동되지 않았습니다",
	"public.all": "전부",
	"public.rules.pleaseLabel": "비고명을 입력해주세요",
	"dispatcher.dispatcherList": "배송원 리스트",
	"dispatcher.searchName": "이름 검색",
	"buiding.deleteShopTips": "먼저 해당 점포의 모든 자산(로봇/지도)과의 연동을 취소해주세요",
	"buiding.deleteBuidingTips": "먼저 해당 건물의 모든 자산(로봇/지도)과의 연동을 취소해주세요",
	"buiding.deleteFloorTips": "먼저 해당 층의 모든 자산(지도)과의 연동을 취소해주세요",
	"ladderControl.ladderControlList": "엘리베이터 컨트롤 리스트",
	"ladderControl.addLadderControl": "엘리베이터 컨트롤 추가",
	"ladderControl.grouping": "그룹 분류",
	"ladderControl.Buildings": "소속 건물",
	"ladderControl.You-can-go-to-the-floor": "해당 층으로 이동하실 수 있습니다",
	"ladderControl.pleaseGoToBuilding": "건물로 이동해주세요,",
	"ladderControl.grouping-tips-1": "그룹 분류는 층을 잘 분간할 수 있는 용도로 사용됩니다",
	"ladderControl.grouping-tips-2": "단 하나의 엘리베이터 또는 여러 개의",
	"ladderControl.grouping-tips-3": "다양한 층, 엘리베이터 대기홀의 엘리베이터는 다른 그룹으로 나눠서 구별시켜야 합니다",
	"public.common": "동",
	"ladderControl.ladderControlID": "엘리베이터 컨트롤 아이디",
	"ladderControl.selectLadderControlID": "엘리베이터 컨트롤 아이디 선택",
	"ladderControl.ladderControlID-tips": "먼저 엘리베이터 컨트롤/출입서비스를 확인하세요. 해당 고객이 이미 엘리베이터 아이디를 설정했습니다",
	"ladderControl.groupingPlaceholder": "그룹을 입력하거나 선택(예:고층 엘리베이터)",
	"ladderControl.deleteladderControl": "엘리베이터 컨트롤 삭제",
	"ladderControl.deleteladderControl-tips": "엘리베이터 컨트롤을 삭제하면 로봇이 다른 층으로 넘어가는 작업을 하지 않을 수 있습니다. 그래도 삭제하시겠습니까?",
	"ladderControl.ladderControlIdExists": "엘리베이터 컨트롤 아이디가 이미 존재합니다",
	"login.remTheNub": "비밀번호를 저장",
	"login.oldPasswordError": "이전 암호가 잘못되었습니다.",
	"login.confirmAndNewParrword": "두 암호가 동일하지 않습니다.",
	"robot.advertising": "광고",
	"homes.buildingDeliveryTimes": "배달 시간",
	"robot.detail": "로봇 세부 정보",
	"robot.robotModel": "로봇 유형",
	"robot.header_control-2": "안드로이드 파워 보드",
	"robot.under_mirror-2": "섀시 ROM",
	"robot.under_master-2": "섀시 마스터 컨트롤",
	"robot.under_control-2": "섀시 전원 보드",
	"robot.nav": "탐색 알고리즘",
	"robot.up_rgbd": "탑 RGBD",
	"robot.down_rgbd": "하단 RGBD",
	"robot.camera": "탑 카메라",
	"robot.ss": "전면 부 카메라",
	"robot.rgbd_top_depth": "최고 RGBD 깊이",
	"robot.rgbd_top_color": "최고 RGBD 색상",
	"robot.rgbd_bottom_depth": "하단 RGBD 깊이",
	"robot.rgbd_bottom_color": "하단 RGBD 색상",
	"robot.ultrasonic1": "왼쪽 초음파",
	"robot.ultrasonic2": "오른쪽 초음파",
	"robot.motor1": "왼쪽 모터",
	"robot.motor2": "오른쪽 모터",
	"robot.detection": "객체 감지",
	"buiding.builNameAlreadyExists": "건물 이름이 이미 존재합니다.",
	"robot.bindingSuccess": "바인드 성공",
	"robot.notActive": "활성화하지 않음",
	"robotinfo.logdown": "일지 다운로드",
	"robotinfo.Logtype": "일지 유형",
	"robotinfo.displayboard": "디스플레이 보드",
	"robotinfo.maincontrolpanel": "메인 컨트롤 보드",
	"robotinfo.powerstrip": "전원대",
	"robotinfo.navigationdata": "내비게이션 데이터",
	"robotinfo.Plethedate": "날짜를 선택해주세요",
	"robotinfo.Plethetime": "시간을 선택해주세요",
	"robotinfo.acquire": "다운로드",
	"robotinfo.Packinglog": "일지를 패키징하고 있습니다",
	"robotinfo.Uploadinglogfiles": "일지 파일을 업로드하고 있습니다",
	"robotinfo.Gettinguploadstatus": "업로드 상태 획득",
	"robotinfo.acquiresuccess": "다운로드 성공",
	"robotinfo.clicktodownload": "클릭해서 다운로드",
	"robotinfo.Plelogtype": "일지 유형을 선택해주세요",
	"robotinfo.Plestartdateandtime": "시작일과 시간을 선택해주세요",
	"robotinfo.Pleanenddateandtime": "종료일과 시간을 선택해주세요",
	"robotinfo.Nologtime": "해당 시간은 일지가 없습니다",
	"robotinfo.logtaskispackagedpackged": "지금 패키징하거나 업로드 중인 일지가 없습니다",
	"robotinfo.failtoget": "다운로드 실패",
	"robotinfo.Failedtopackage1/2": "1/2 패키징 실패",
	"robotinfo.Failedtopackage2/2": "2/2 패키징 실패",
	"robotinfo.failtoupload": "업로드 실패",
	"public.unrelatedBuildings": "건물 연동하지 않음",
	"buiding.sameFloorNumber": "해당 건물은 같은 층 번호가 존재합니다",
	"navigationBar.pleaseEnterOriginalPsd": "초기 비밀번호",
	"navigationBar.newpassword": "비밀번호를 입력해주세요(6-20자리의 숫자, 영문자, 기호를 입력하세요)",
	"navigationBar.pleaseNewpassword": "새 비밀번호를 입력하세요",
	"login.nnterprise-number-error": "기업번호 오류",
	"home.Fullrobot": "모든 로봇",
	"map.displaytext": "문자 표시",
	"map.nonetext": "문자 표시하지 않음",
	"robot.detection-1": "객체 감지 1",
	"robot.detection-2": "객체 감지 2",
	"robot.detection-3": "객체 감지 3",
	"robot.detection-4": "객체 감지 4",
	"robot.current_systemVersion": "현재 버전",
	"robot.cumulativeTimes": "누적 음식 배송 횟수",
	"robot.cumulativeTime": "누적 음식 배송 시간",
	"home.hour": "시간",
	"home.min": "분",
	"home.deliverytimes": "배송 횟수(번)",
	"login.actpaswdinco": "아이디 또는 비밀번호 오류",
	"login.enterpriseerror": "기업번호 오류",
	"home.numberofworkmachs": "작동 중인 로봇수",
	"home.workinghours": "근무 시간",
	"login.account_expired": "아이디 기한 초과, 다시 로그인 해주시기 바랍니다",
	"robot.CADEBOT_rankingList_tips": "목적지 음식 배송 횟수 랭킹",
	"robot.setLabel": "비고명 설정성공",
	"homes.nearly-7-days-mileage": "최근 7일 마일리지 추세",
	"robot.robotisofflineobtalogs": "로봇 오프라인 상태, 일지를 가져올 수 없습니다.",
	"buiding.buid-illustrate": "건물(여러 층의 경우)",
	"buiding.shop-illustrate": "매장(단층용)",
	"buiding.new-pleaseFloorName": "층 이름을 입력하세요.",
	"route.admage": "광고",
	"route.asset": "리소스 라이브러리",
	"route.ads": "광고 릴리스",
	"route.adsDetail": "광고 세부 정보",
	"route.addAds": "광고 추가",
	"route.editAds": "광고 수정",
	"ad.asset": "리소스 목록",
	"ad.freeSpace": "남은 공간",
	"ad.uploadAsset": "리소스 업로드",
	"ad.filename": "파일 이름",
	"ad.type": "유형",
	"ad.memory": "메모리",
	"ad.video": "동영상",
	"ad.image": "이미지",
	"ad.uploadTime": "업로드 시간",
	"ad.uploadProgress": "업로드 진행률",
	"ad.uploadSuccess": "업로드 성공",
	"ad.operation": "작동 중",
	"ad.check": "보기",
	"ad.delete": "삭제",
	"ad.confirm": "확인",
	"ad.cancel": "취소",
	"ad.deleteSuccess": "성공적으로 삭제됨",
	"ad.back": "돌아가기",
	"ad.deleteAsset": "리소스 삭제하기",
	"ad.deleteAssetWarningMessage": "삭제된 리소스는 복구되지 않으니 삭제를 확인하시겠습니까?",
	"ad.extLimit": "JPG, PNG, MP4, AVI, MOV, WMV, RMVB 형식의 파일만 업로드할 수 있습니다.",
	"ad.sizeLimit": "단일 파일은 1GB를 초과할 수 없습니다.",
	"ad.syncFail": "다운로드 실패",
	"ad.syncComplete": "다운로드 완료",
	"ad.downloadComplete": "구성 진행 중",
	"ad.downloadWaiting": "다운로드되지 않음",
	"ad.name": "이름",
	"ad.playTime": "재생 시간대",
	"ad.materialNum": "리소스 수",
	"ad.robotNum": "캐스트 로봇 수",
	"ad.startTime": "게시 시간",
	"ad.addSchema": "광고 추가",
	"ad.copySchema": "복사 계획",
	"ad.edit": "편집",
	"ad.publish": "게시",
	"ad.deleteDraft": "요금제 삭제",
	"ad.save": "저장",
	"ad.preview": "미리보기",
	"ad.setDefault": "지금 사용",
	"ad.setDefaultPlease": "기본값으로 설정하세요.",
	"ad.yes": "예",
	"ad.no": "아니요",
	"ad.deleteDraftWarningMessage": "프로그램 삭제를 확인하시겠습니까?",
	"ad.draft": "게시되지 않음",
	"ad.schemaDetail": "플랜 세부 정보",
	"ad.schemaContent": "플랜 콘텐츠",
	"ad.syncRecord": "동기화된 녹화",
	"ad.robotSn": "로봇 삭제",
	"ad.robotSelect": "로봇 선택",
	"ad.nameInput": "요금제 이름 입력",
	"ad.robotSelectPlease": "로봇을 선택해 주세요",
	"ad.nameInputPlease": "방안 이름을 입력해주세요",
	"ad.materialList": "리소스 목록",
	"ad.materialListDescriptions": "광고 스크린 크기는 1080*1920입니다, 카드를 드래그하시면 순서를 조절하실 수 있습니다",
	"ad.setting": "배치 설정",
	"ad.period": "기간",
	"ad.allDay": "하루 종일",
	"ad.someTime": "시간대",
	"ad.beginTime": "시작 시간",
	"ad.endTime": "종료 시간",
	"ad.materialLib": "리소스 라이브러리",
	"ad.materialNumber": "리소스 수",
	"ad.removeScreen": "분할 화면 삭제",
	"ad.removeScreenConfirm": "분할 화면 삭제를 확인하시겠습니까?",
	"ad.playTimeDuration": "재생 시간",
	"ad.picturePlayTime": "이미지 재생 시간",
	"ad.addPeriod": "시간 슬롯 추가",
	"ad.addPeriodLimit": "6가지 시간 슬롯을 추가할 수 있습니다.",
	"ad.totalTime": "총 재생 시간",
	"ad.saveSuccess": "저장 성공",
	"ad.publishSuccess": "게시 성공",
	"ad.addPeriodFail": "이미 하루 종일 시간 슬롯이 있어 추가할 수 없습니다.",
	"ad.publishFail": "게시 실패",
	"ad.playTimeNoEmpty": "재생 시간을 비워둘 수 없음",
	"ad.materialListNoEmpty": "분할 화면을 비워둘 수 없습니다.",
	"ad.robot": "로봇 ",
	"ad.robotOffline": "오프라인 상태의 로봇",
	"ad.robotOfflineAndCanNotLaunch": "다음 로봇은 오프라인 상태이므로 배치할 수 없습니다.",
	"ad.robotUplineOrSaveDraft": "로봇을 온라인으로 작동하거나 먼저 계획을 초안으로 저장하세요.",
	"ad.syncStatus": "로봇 다운로드 상태",
	"ad.reSync": "재게시",
	"ad.goBackList": "목록으로 돌아가기",
	"ad.confirmPublish": "게시하시겠습니까?",
	"ad.robotOfflineToConfirmPublish": "다음 로봇이 오프라인 상태인데 게시를 확인하시겠습니까?",
	"ad.addCancelConfirm": "복귀 후 현재 콘텐츠가 저장되지 않음을 확인하시겠습니까?",
	"ad.refresh": "새로고침",
	"ad.publishTime": "게시 시간",
	"ad.lastModifyTime": "마지막으로 수정한 시간",
	"ad.publisher": "게시한 사람",
	"ad.editor": "수정한 사람",
	"ad.timeOverlap": "재생 기간은 겹칠 수 없으니 다음 사항을 확인하세요.",
	"ad.endTimeMustLargerThanStartTime": "재생 기간의 종료 시간이 시작 시간보다 커야 합니다.",
	"ad.cannotDeleteAssetUsed": "이 클립은 참조되어 삭제할 수 없습니다.",
	"ad.deletePeriodWarningMessage": "시간 슬롯 삭제를 확인하시겠습니까?",
	"ad.complete": "완료",
	"ad.fail": "실패",
	"ad.nameInputIllegal": "요금제 이름에 특수 문자를 포함할 수 없습니다.",
	"ad.nameDuplicate": "계획 이름이 이미 존재합니다.",
	"ad.updateTime": "최근 수정 시간",
	"role.TherolesDeletingfails": "역할이 계정에 바인딩되어 삭제에 실패했습니다.",
	"account.Changeofauthority": "권한 변경",
	"account.ThepermisschgePleaseagain": "이 계정의 권한이 변경되었습니다.",
	"disinfect.Unknowncause": "알려진 이유 없음",
	"robot.accumulatedTaskExecutionTimes": "수행한 누적 작업 수",
	"home.minute": "분",
	"homes.Statisticstasks": "로봇이 작업을 수행한 통계(진행 중인 작업)",
	"disinfect.Initilizati": "초기화 실패",
	"disinfect.Failedtogetlocation": "위치 가져오기 실패",
	"disinfect.pointisoffthemap": "목표점이 지도 밖에 있습니다",
	"disinfect.onastaticobstacle": "목표점이 정적 장애물에 있습니다",
	"disinfect.therearenoroadsonthestaticmap": "정적 지도에 길이 없습니다",
	"disinfect.Startingpointobstacle": "출발점에 장애물이 있습니다",
	"disinfect.Lossoflocation": "위치 잃어버림",
	"disinfect.Failedtolocatethelostlocalpath": "부분 경로 기획 실패",
	"disinfect.Clifftriggercancellation": "절벽에 닿을 때 임무 취소",
	"disinfect.Emergencystoptriggerscancellation": "급 정지 버튼 누를 시 임무 취소",
	"disinfect.Collisionbartriggercancel": "방지턱 촉발 취소",
	"disinfect.overtime": "시간 초과",
	"disinfect.Chargingpiledetectionfailed": "충전대 테스트 실패",
	"disinfect.Pilefailure": "충전대 오르기 실패",
	"disinfect.GlobalpathplanningfailedProcedure": "전체 경로 기획 실패",
	"disinfect.Slopetriggercancellation": "경사면 촉발 취소",
	"disinfect.NavigationrecoverybeProcedure": "내비게이션 복구 실패",
	"disinfect.Navigateoutnarrowchannel": "좁은 경로가 차단됨",
	"disinfect.Androidtasktimeout": "작업 시간 초과",
	"disinfect.elsesa": "기타 오류",
	"robot.historicaldelete": "이 로봇의 기록 데이터가 삭제됩니다. 삭제를 확인하시겠습니까?",
	"robot.delfaild": "삭제 실패",
	"robot.LoRa_ID": "LoRa ID",
	"robot.associatedSIMCard": "연결된 SIM 카드",
	"robot.accumulatedUsageTraffic": "누적 트래픽 사용량",
	"robot.trafficUsageMonth": "월간 트래픽 사용량",
	"robot.newrgbd_bottom_depth": "하단 RGBD 깊이",
	"robot.batteryTest": "배터리 감지",
	"robot.Partial_information_update_failed": "일부 정보를 업데이트하지 못했습니다.",
	"robot.update_failed": "업데이트가 실패",
	"robot.update_robot_datasSuccess": "로봇의 최신 데이터를 성공적으로 가져옵니다.",
	"ad.waitForDownload": "다운로드 대기 중",
	"ad.startDownload": "다운로드를 시작하다",
	"ad.offLineAndCannotDownload": "기기 오프라인, 다운로드 불가",
	"ad.syncing": "동기화 중...",
	"robot.robot_does_not_exist": "로봇이 존재하지 않습니다",
	"robot.robot_current_enterprise": "로봇은 현재 기업을 떠났습니다.",
	"ad.notEnoughSpace": "기업 자료를 위한 공간이 부족합니다. 제 시간에 파일을 정리하십시오.",
	"ad.addAsset": "재료 추가",
	"robot.batteryCommunication": "배터리 통신",
	"disinfect.Thetargetpointisobstacle": "목표 지점이 동적 장애물 위에 있습니다.",
	"disinfect.Therearenoroadsonadynamicmap": "동적 지도에 도로가 없습니다.",
	"robot.buildingRobotErrorTips_10019": "이 상점의 로봇 수가 상한인 16대에 도달했습니다. 건물(상점)을 변경하십시오.",
	"robot.buildingRobotErrorTips_10020": "LoraId 생성 오류",
	"map.VirtualWall": "가상벽",
	"map.tracks": "궤도",
	"map.Qrcode": "QR 코드",
	"map.regions": "영역",
	"map.anchorpoints": "위치 포인트",
	"robot.noSearchResults": "검색 결과 없음",
	"robot.accountInformationHasBeenModified": "계정 정보가 수정되었습니다",
	"public.tips": "힌트",
	"public.agreeWith": "동의하다",
	"public.iHaveReadAndAgree": "읽었으며 동의합니다",
	"public.userAgreement": "사용자 계약",
	"public.gentle": "그리고",
	"public.privacyAgreement": "개인 정보 정책",
	"public.pleaseAgreeFirst": "먼저 동의해주세요",
}
